import React from 'react';

import { css } from '@emotion/css';
import { DatePicker } from '@opendoor/bricks/complex/DatePicker';
import { Label } from '@opendoor/bricks/core';
import moment from 'moment';

const styles = {
  field_bottom_padding: css`
    padding-bottom: 25px;
    width: 100%;
  `,
};

export type DateChangeHandler = (date: moment.Moment | Date) => void;

interface ParnDateFieldProps {
  id: string;
  label: string;
  value: moment.Moment | Date | undefined;
  onChangeHandler: DateChangeHandler;
}

// storybook-check-ignore
export const ParnDateField: React.FC<ParnDateFieldProps> = ({
  id,
  label,
  value,
  onChangeHandler,
}) => {
  const currentYear = new Date().getFullYear();

  return (
    <div className={styles.field_bottom_padding}>
      <DatePicker
        id={id}
        label={
          <Label htmlFor={id}>
            {label}
            <span style={{ color: '#c34143' }}> *</span>
          </Label>
        }
        initialDate={value}
        placeholder={`January 1, ${currentYear}`}
        onDateChange={(date) => onChangeHandler(moment(date))}
      />
    </div>
  );
};

export default ParnDateField;
